import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TMigrateContractorPaymentRequest,
  TMigrateContractorPaymentResponse,
} from "./migrateContractorPayment.schema";

export const migrateContractorPayment = (axios: IAxiosInstance) => {
  return async (
    body: TMigrateContractorPaymentRequest
  ): Promise<TMigrateContractorPaymentResponse> => {
    const response = await axios.noRetry.post<
      IApiResponse<TMigrateContractorPaymentResponse>
    >(`/api/migrate/contractor-payment`, body);
    return response.data.data;
  };
};
